<template>
    <v-container fluid fill-height pa-6 class="main-container">
        <v-layout justify-center align-center class="auth-layout">
            <v-flex text-center>
                <div v-html="require('!html-loader!@/assets/images/logo_image.svg')" class="d-inline-flex mb-60" />
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    class="auth-form"
                    @submit.prevent
                >
                    <div class="auth-form__input mb-1">
                        <label for="email" class="main-text"> E-mail </label>
                        <v-text-field
                            v-model="email"
                            id="email"
                            placeholder="Введите e-mail"
                            class="dark-input"
                            :rules="rules"
                            :error="error"
                            :error-messages="errorMessage"
                            @input="deleteError"
                        ></v-text-field>
                    </div>
                    <div class="auth-form__input mb-60">
                        <label for="password" class="main-text"> Пароль </label>
                        <v-text-field
                            v-model="password"
                            id="password"
                            :rules="rules"
                            :type="showPassword ? 'text' : 'password'"
                            placeholder="Введите пароль"
                            class="dark-input ma-0"
                            hide-details
                            dense
                            @input="deleteError"
                        >
                            <template v-slot:append>
                                <div
                                    v-if="showPassword"
                                    v-html="require('!html-loader!@/assets/icons/eye_icon.svg')"
                                    class="img-form"
                                    @click="showPassword = !showPassword"
                                />
                                <div
                                    v-else
                                    v-html="require('!html-loader!@/assets/icons/eye_closed_icon.svg')"
                                    class="img-form"
                                    @click="showPassword = !showPassword"
                                />
                            </template>
                        </v-text-field>
                    </div>
                    <v-btn
                        :disabled="!valid || !(email && password)"
                        class="yellow-btn"
                        type="submit"
                        @click="validate"
                    >
                        Войти
                    </v-btn>
                    <div class="w-100 d-inline-flex justify-center mt-5">
                        <a href="#" class="auth-link" @click.prevent="openReset">
                            Забыли пароль?
                        </a>
                    </div>
                </v-form>
            </v-flex>
        </v-layout>
        <ModalMessage
            v-model="modalOpen"
            title="Неверные e-mail или пароль"
            text="Проверьте правильность ввода и повторите попытку"
            text-btn="Хорошо"
            text-center
        />
    </v-container>
</template>

<script>
import ModalMessage from "@/components/modals/ModalMessage";
export default {
    name: 'LoginPage',
    components: {ModalMessage},
    data() {
        return {
            email: null,
            password: null,
            valid: true,
            showPassword: false,
            error: null,
            errorMessage: null,
            rules: [value => !!value || 'Обязательное поле'],
            modalOpen: false,
        };
    },
    mounted() {
        window.addEventListener("message", (event) => {
            if (event.origin !== process.env.VUE_APP_ADMIN_URL) return;

            if (typeof(event.data) === "string" && !this.$store.state.accessToken) {
                localStorage.RobohomeDataAccessToken = event.data;
                this.$router.push( '/');
                this.$router.go( 0);
            }
        });
    },
    methods: {
        logIn() {
            this.$http.post('/users/home/login/', {
                email: this.email,
                password: this.password,
            })
                .then((response) => {
                    localStorage.RobohomeDataAccessToken = response.data.access_token;
                    this.$router.push( '/');
                    this.$router.go( 0);
                })
                .catch((error) => {
                    console.error(error);
                    this.modalOpen = true;
                });
        },
        validate() {
            this.valid = this.$refs.form.validate();
            if (this.valid) {
                this.logIn();
            } else {
                this.errorMessage = "Обязательное поле";
            }
        },
        deleteError() {
            this.errorMessage = null;
            this.error = false;
        },
        openReset() {
            this.$router.push({ name: "resetpassword" });
        }
    }
}
</script>

<style scoped>
</style>